import { Box, styled } from "@mui/material";

export const RecipientTopBarChannelBadge = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.info.main,
  color: theme.palette.info.contrastText,
  borderRadius: theme.shape.borderRadiusMd,
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: theme.spacing(6),
  width: theme.spacing(8),
}));

export const RecipientTopBarToggle = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.background["paper-elevation-3"],
  borderRadius: theme.shape.borderRadiusButtonCorner,
  padding: theme.spacing(2),
  marginLeft: theme.spacing(3),
}));

export const RecipientTopBarToggleButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active?: boolean }>(({ theme, active }) => ({
  width: theme.spacing(9),
  borderRadius: theme.shape.borderRadiusButtonCorner,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: theme.spacing(6),
  transition: theme.transitions.create(["color", "background-color"], {
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeInOut,
  }),
  backgroundColor: active ? theme.palette.primary.main : "transparent",
}));
